var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultTimeBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2537 1.7423L9.70605 3.93825C9.82119 4.50986 9.4552 5.06913 8.88359 5.18427C8.31199 5.29941 7.75272 4.93342 7.63758 4.36182L7.18523 2.16586C7.07008 1.59426 7.43608 1.03499 8.00768 0.919847C8.57928 0.804703 9.13855 1.1707 9.2537 1.7423Z",
    fill: "#296D9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35673 1.58606L7.0333 2.06308C6.60562 2.14944 6.18617 1.87391 6.09982 1.44624C6.01346 1.01856 6.28898 0.599111 6.71666 0.512753L9.0442 0.0357297C9.47187 -0.050628 9.89132 0.224894 9.97768 0.65257C10.064 1.08025 9.78852 1.4997 9.35673 1.58606Z",
    fill: "#4F95CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7465 11.5419C16.7465 14.9879 13.9419 17.7884 10.4999 17.7884C7.05798 17.7884 4.25342 14.9838 4.25342 11.5419C4.25342 8.10401 7.05798 5.29944 10.4999 5.29944C13.9419 5.29944 16.7465 8.10401 16.7465 11.5419Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 3.09937C5.84062 3.09937 2.05322 6.89088 2.05322 11.5419C2.05322 16.2011 5.84473 19.9885 10.4998 19.9885C15.1549 19.9885 18.9464 16.1969 18.9464 11.5419C18.9464 6.89088 15.159 3.09937 10.4998 3.09937ZM10.4998 17.7884C7.05374 17.7884 4.25328 14.9838 4.25328 11.5419C4.25328 8.104 7.05785 5.29943 10.4998 5.29943C13.9418 5.29943 16.7463 8.104 16.7463 11.5419C16.7463 14.9879 13.9459 17.7884 10.4998 17.7884Z",
    fill: "#4F95CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 10.7148H14.1797C14.5976 10.7148 14.9336 11.0547 14.9336 11.4688C14.9336 11.8867 14.5937 12.2227 14.1797 12.2227H10.7812C10.3633 12.2227 10.0273 11.8828 10.0273 11.4688C10.0273 11.0547 10.3672 10.7148 10.7812 10.7148Z",
    fill: "#296D9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5352 12.9844C11.3161 12.9844 11.9492 12.3076 11.9492 11.4727C11.9492 10.6378 11.3161 9.96094 10.5352 9.96094C9.75419 9.96094 9.12109 10.6378 9.12109 11.4727C9.12109 12.3076 9.75419 12.9844 10.5352 12.9844Z",
    fill: "#68BAE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultTimeBlue);
export default __webpack_public_path__ + "static/media/result_time_blue.9786f4dba35a96ff057c0a0d4f5ca4fc.svg";
export { ForwardRef as ReactComponent };